import React from 'react';
import LargeContainer from '@/components/front-office/containers/LargeContainer';
import Button from '@/components/Button';

const NotFound = () => {
	return (
		<LargeContainer>
			<div style={{ textAlign: 'center', marginTop: '50px' }}>
				<h1 className='text-xl'>Nous n'avons pas trouvé la page que vous recherchiez.</h1>
				<p className='mb-12 text-lg'>Il est possible que la page que vous recherchez n'existe pas.</p>

				<Button
					text={`Revenir à la page d'accueil`}
					type={'Button'}
					action="button"
					handleClick={() => (window.location.href = '/')}
					disabled={true}
					withTopMargin={false}
					extraClasses="text-xs md:text-sm"
				/>
			</div>
		</LargeContainer>
	);
};

export default NotFound;
